<template>
    <div>
        <z-title title="报表管理统计"></z-title>
        <el-card class="content1">
            <div class="flex-n fac fjb">
                <div class="flex-n fac">
                    <div class="textnowrap">订单状态：</div>


                    <order-confirm-state clearable class="mr-10 " size="medium" v-model="orderStates"
                                         placeholder="请选择"></order-confirm-state>
                    <div class="textnowrap">套餐类型：</div>
                    <package-types class=" mr-10 " clearable size="medium" v-model="packageIds"
                                   placeholder="请选择" multiple></package-types>
                    <div class="textnowrap">场地：</div>
                    <want-house class="mr-10 " multiple clearable size="medium" v-model="houseIds" placeholder="请选择"></want-house>

                </div>
                <el-button type="primary" class="ele-btn2">重置</el-button>

            </div>
            <div class="flex-n fac fjb mt-10">
                <div class="flex-n fac">

                    <div class="textnowrap">下单日期：</div>
                    <el-date-picker
                            size="medium"
                            class="mr-10 date w-220"
                            v-model="orderDateRange"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                    >
                    </el-date-picker>

                <div class="textnowrap">订单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date w-220"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                </div>
                <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>

            </div>
            <div class="flex-n fac mt-10">
                <div class="textnowrap">销售：</div>
                <saler-list class="flex-1"  clearable size="medium" v-model="createUserIds" multiple placeholder="请选择销售" ></saler-list>
            </div>

        </el-card>

        <div class="report-tag">
            <div class="title">预定统计</div>
            <div class="tag-bg"></div>
        </div>
        <el-card>
            <div class="flex-n fac">
                <div id="bar" style="width: 50%;height: 300px"></div>
                <div id="bar2" style="width: 50%;height: 300px"></div>
            </div>
            <div class="flex-n fac report-total">
                <div>订单数量： {{reportOrderCalc.orderCount}}场</div>
                <div>预计收入: {{reportOrderCalc.orderMoney}}元</div>
                <div>桌数:  {{reportOrderCalc.deskCount}}桌</div>
                <div>人数: {{reportOrderCalc.personCount}}人</div>
            </div>
        </el-card>
        <div class="report-tag">
            <div class="title">结算统计</div>
            <div class="tag-bg"></div>
        </div>
        <el-card>
            <div class="flex-n fac">
                <div id="bar3" style="width: 50%;height: 300px"></div>
                <div id="bar4" style="width: 50%;height: 300px"></div>
            </div>
            <div class="flex-n fac report-total">
                <div>预订桌数: {{reportOrderClear.deskCount}}桌</div>
                <div>预订人数:{{reportOrderClear.personCount}}人</div>
                <div>预计收入: {{reportOrderClear.orderMoney}}元</div>
                <div>订单数量:{{reportOrderClear.orderCount}}单</div>
            </div>
            <div class="flex-n fac report-total">
                <div>结算桌数: {{reportOrderClear.clearDeskCount}}桌</div>
                <div>结算人数:{{reportOrderClear.clearPersonCount}}人</div>
                <div>实际收入: {{reportOrderClear.realMoney}}元</div>
                <div>收入差额: {{reportOrderClear.differenceMoney}}元</div>
            </div>
        </el-card>
    </div>
</template>

<script>
    // 引入 ECharts 主模块
    import echarts from 'echarts/lib/echarts';
    import 'echarts/lib/chart/bar';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/title';
    import ZTitle from "../../components/ZTitle";
    import PackageTypes from "../../components/data/packageTypes";
    import OrderConfirmState from "../../components/data/orderConfirmState";
    import WantHouse from "../../components/data/wantHouse";
    import SalerList from "../../components/data/salerList";

    var clear1,clear2,clear3,clear4;
    export default {
        components: {
            SalerList,
            WantHouse,
            OrderConfirmState,
            PackageTypes,
            ZTitle
        },
        name: "report",
        data() {
            return {
                orderStates:'',
                packageIds:[],
                houseIds:[],
                createUserIds:[],
                orderDateRange: [],
                dateRange: [],
                reportOrderHouseList: [],
                reportOrderSalesList:[],
                reportOrderHouseConfirmList:[],
                reportOrderSalesConfirmList:[],
                reportOrderCalc:{},
                reportOrderClear:{}
            }
        },
        computed: {
            pickerOptions() {
                var that = this;
                return {
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num = start.getDay();
                                if (num == 0) {
                                    num = 7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num - 1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7 - num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num = start.getDay();
                                if (num == 0) {
                                    num = 7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num + 6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year = start.getFullYear(), month = start.getMonth() + 1;
                                var startDate = new Date(year + '-' + month + '-1');
                                var length = that.$TM.getMonthArea().length - 1;
                                var dd = that.$TM.getMonthArea()[length].dd;
                                var endDate = new Date(that.$TM.getMonthArea()[length - (dd < 7 ? dd : 0)].date);
                                console.log(startDate, endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({
                                    yy: start.getFullYear(),
                                    mm: start.getMonth() + 1,
                                    dd: 1
                                }))
                                var month = that.$TM.beforeMouth({
                                        yy: start.getFullYear(),
                                        mm: start.getMonth() + 1,
                                        dd: 1
                                    })[15].mm,
                                    year = that.$TM.beforeMouth({
                                        yy: start.getFullYear(),
                                        mm: start.getMonth() + 1,
                                        dd: 1
                                    })[15].yy;
                                var length = that.$TM.beforeMouth({
                                    yy: start.getFullYear(),
                                    mm: start.getMonth() + 1,
                                    dd: 1
                                }).length - 1;
                                var dd = that.$TM.beforeMouth({
                                    yy: start.getFullYear(),
                                    mm: start.getMonth() + 1,
                                    dd: 1
                                })[length].dd;
                                var startDate = new Date(year + '-' + month + '-1');
                                var endDate = new Date(that.$TM.beforeMouth({
                                    yy: start.getFullYear(),
                                    mm: start.getMonth() + 1,
                                    dd: 1
                                })[length - (dd < 7 ? dd : 0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },
        },
        mounted() {
            this.getReportOrderHouse();
            this.getReportOrderSales();
            this.getReportOrderHouseConfirm();
            this.getReportOrderSalesConfirm();
            this.getReportOrderCalc();
            this.getReportOrderClear();
        },
        methods: {
            searchList(){
                this.getReportOrderHouse();
                this.getReportOrderSales();
                this.getReportOrderHouseConfirm();
                this.getReportOrderSalesConfirm();
                this.getReportOrderCalc();
            },
            //预定场地统计
            getReportOrderHouse() {
                this.$axios.post('/report/reportOrderHouse', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    console.log(res.data)
                    this.reportOrderHouseList = res.data.list;
                    this.getReportOrderHouseChart();
                }).catch(err => {

                })
            },
            getReportOrderHouseChart() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('bar'));
// 绘制图表
                var reportOrderHouseList = this.reportOrderHouseList;
                var houseNameList = [], orderRateList = [], moneyRateList = [];
                for (var i = 0; i < reportOrderHouseList.length; i++) {
                    houseNameList.push(reportOrderHouseList[i].houseName);
                    orderRateList.push(Number(Number(reportOrderHouseList[i].orderRate) * 100).toFixed(2));
                    moneyRateList.push(Number(Number(reportOrderHouseList[i].moneyRate) * 100).toFixed(2));
                }
                myChart.setOption({
                    title: {
                        x: 'center',
                        y: 'top',
                        textStyle: {
                            color: '#666',
                            fontSize: 14
                        },
                        text: '预订场地统计',
                    },
                    grid:{
                        y2:70
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: function (params) {
                            return params[0].name + '<br/>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #2da9fa"></div>'
                                + reportOrderHouseList[params[0].dataIndex].orderCount + '场 / '
                                + params[0].data + '%</div>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #1ec695"></div>'
                                + Number(reportOrderHouseList[params[1].dataIndex].orderMoney).toFixed(2) + '元 / ' + params[1].data +
                                '%</div>';
                        }
                    },
                    legend: {
                        data: ['预订场地数量/占比', '预订场地业绩/占比'],
                        top: 26,
                        right:0,
                        selectedMode:false
                    },
                    xAxis: {
                        name: '',
                        data: houseNameList,
                        axisLabel: {
                            interval: 0,
                            formatter:function(value)
                            {
                                return value.split("").join("\n");
                            }
                            // rotate: 20
                        }
                    },
                    yAxis: {
                        name: '单位：百分比',
                        max: 100,
                        nameTextStyle: {
                            color: '#aaa',
                        }
                    },
                    series: [{
                        type: 'bar',
                        name: '预订场地数量/占比',
                        data: orderRateList,
                        color: '#2da9fa',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }, {
                        name: '预订场地业绩/占比',
                        type: 'bar',
                        data: moneyRateList,
                        color: '#1ec695',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }]
                });
                clear1 = setInterval(() => {
                    myChart.resize();
                }, 500)
            },
            //销售预定统计
            getReportOrderSales() {
                this.$axios.post('/report/reportOrderSales', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    console.log(res.data)
                    this.reportOrderSalesList = res.data.list;
                    this.getReportOrderSalesChart();
                }).catch(err => {

                })
            },
            getReportOrderSalesChart(){
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('bar2'));
// 绘制图表
                var reportOrderSalesList = this.reportOrderSalesList;
                var houseNameList = [], orderRateList = [], moneyRateList = [];
                for (var i = 0; i < reportOrderSalesList.length; i++) {
                    houseNameList.push(reportOrderSalesList[i].userName);
                    orderRateList.push(Number(Number(reportOrderSalesList[i].orderRate) * 100).toFixed(2));
                    moneyRateList.push(Number(Number(reportOrderSalesList[i].moneyRate) * 100).toFixed(2));
                }
                myChart.setOption({
                    title: {
                        x: 'center',
                        y: 'top',
                        textStyle: {
                            color: '#666',
                            fontSize: 14
                        },
                        text: '销售预定统计',
                    },
                    grid:{
                      y2:70
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: function (params) {
                            return params[0].name + '<br/>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #2da9fa"></div>'
                                + reportOrderSalesList[params[0].dataIndex].orderCount + '场 / '
                                + params[0].data + '%</div>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #1ec695"></div>'
                                + Number(reportOrderSalesList[params[1].dataIndex].orderMoney).toFixed(2) + '元 / ' + params[1].data +
                                '%</div>';
                        }
                    },
                    legend: {
                        data: ['销售预订场地数量/占比', '销售预订场地业绩/占比'],
                        top: 26,
                        right:0,
                        selectedMode:false
                    },
                    xAxis: {
                        name: '',
                        data: houseNameList,
                        axisLabel: {
                            interval: 0,
                            // rotate: 20,
                            formatter:function(value)
                            {
                                return value.split("").join("\n");
                            }
                        }
                    },
                    yAxis: {
                        name: '单位：百分比',
                        max: 100,
                        nameTextStyle: {
                            color: '#aaa',
                        }
                    },
                    series: [{
                        type: 'bar',
                        name: '销售预订场地数量/占比',
                        data: orderRateList,
                        color: '#2da9fa',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }, {
                        name: '销售预订场地业绩/占比',
                        type: 'bar',
                        data: moneyRateList,
                        color: '#1ec695',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }]
                });
                clear2 = setInterval(() => {
                    myChart.resize();
                }, 500)
            },
            //结算场地统计
            getReportOrderHouseConfirm(){
                this.$axios.post('/report/reportOrderHouseConfirm', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    console.log(res.data)
                    this.reportOrderHouseConfirmList = res.data.list;
                    this.getReportOrderHouseConfirmChart();
                }).catch(err => {

                })
            },
            getReportOrderHouseConfirmChart(){
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('bar3'));
// 绘制图表
                var reportOrderHouseConfirmList = this.reportOrderHouseConfirmList;
                var houseNameList = [], orderRateList = [], moneyRateList = [];
                for (var i = 0; i < reportOrderHouseConfirmList.length; i++) {
                    houseNameList.push(reportOrderHouseConfirmList[i].houseName);
                    orderRateList.push(Number(Number(reportOrderHouseConfirmList[i].orderRate) * 100).toFixed(2));
                    moneyRateList.push(Number(Number(reportOrderHouseConfirmList[i].realMoneyRate) * 100).toFixed(2));
                }
                myChart.setOption({
                    title: {
                        x: 'center',
                        y: 'top',
                        textStyle: {
                            color: '#666',
                            fontSize: 14
                        },
                        text: '结算场地统计',
                    },
                    grid:{
                        y2:70
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: function (params) {
                            return params[0].name + '<br/>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #2da9fa"></div>'
                                + reportOrderHouseConfirmList[params[0].dataIndex].orderCount + '场 / '
                                + params[0].data + '%</div>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #1ec695"></div>'
                                + Number(reportOrderHouseConfirmList[params[1].dataIndex].orderRealMoney).toFixed(2) + '元 / ' + params[1].data +
                                '%</div>';
                        }
                    },
                    legend: {
                        data: ['结算场地数量/占比', '结算场地业绩/占比'],
                        top: 26,
                        right:0,
                        selectedMode:false
                    },
                    xAxis: {
                        name: '',
                        data: houseNameList,
                        axisLabel: {
                            interval: 0,
                            // rotate: 20,
                            formatter:function(value)
                            {
                                return value.split("").join("\n");
                            }
                        }
                    },
                    yAxis: {
                        name: '单位：百分比',
                        max: 100,
                        nameTextStyle: {
                            color: '#aaa',
                        }
                    },
                    series: [{
                        type: 'bar',
                        name: '销售预订场地数量/占比',
                        data: orderRateList,
                        color: '#2da9fa',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }, {
                        name: '销售预订场地业绩/占比',
                        type: 'bar',
                        data: moneyRateList,
                        color: '#1ec695',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }]
                });
                clear3 = setInterval(() => {
                    myChart.resize();
                }, 500)
            },
            //销售结算统计
            getReportOrderSalesConfirm(){
                this.$axios.post('/report/reportOrderSalesConfirm', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    console.log(res.data)
                    this.reportOrderSalesConfirmList = res.data.list;
                    this.getReportOrderSalesConfirmChart();
                }).catch(err => {

                })
            },
            getReportOrderSalesConfirmChart(){
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('bar4'));
// 绘制图表
                var reportOrderSalesConfirmList = this.reportOrderSalesConfirmList;
                var houseNameList = [], orderRateList = [], moneyRateList = [];
                for (var i = 0; i < reportOrderSalesConfirmList.length; i++) {
                    houseNameList.push(reportOrderSalesConfirmList[i].userName);
                    orderRateList.push(Number(Number(reportOrderSalesConfirmList[i].orderRate) * 100).toFixed(2));
                    moneyRateList.push(Number(Number(reportOrderSalesConfirmList[i].realMoneyRate) * 100).toFixed(2));
                }
                myChart.setOption({
                    title: {
                        x: 'center',
                        y: 'top',
                        textStyle: {
                            color: '#666',
                            fontSize: 14
                        },
                        text: '销售结算统计',
                    },
                    grid:{
                        y2:70
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: function (params) {
                            return params[0].name + '<br/>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #2da9fa"></div>'
                                + reportOrderSalesConfirmList[params[0].dataIndex].orderCount + '场 / '
                                + params[0].data + '%</div>' +
                                '<div class="flex-n fac">' +
                                '<div class="mr-10" style=" width: 10px; height: 10px;border-radius: 50%; background: #1ec695"></div>'
                                + Number(reportOrderSalesConfirmList[params[1].dataIndex].realMoneyRate).toFixed(2) + '元 / ' + params[1].data +
                                '%</div>';
                        }
                    },
                    legend: {
                        data: ['销售结算场地数量/占比', '销售结算场地业绩/占比'],
                        top: 26,
                        right:0,
                        selectedMode:false
                    },
                    xAxis: {
                        name: '',
                        data: houseNameList,
                        axisLabel: {
                            interval: 0,
                            // rotate: 20,
                            formatter:function(value)
                            {
                                return value.split("").join("\n");
                            }
                        }
                    },
                    yAxis: {
                        name: '单位：百分比',
                        max: 100,
                        nameTextStyle: {
                            color: '#aaa',
                        }
                    },
                    series: [{
                        type: 'bar',
                        name: '销售预订场地数量/占比',
                        data: orderRateList,
                        color: '#2da9fa',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }, {
                        name: '销售预订场地业绩/占比',
                        type: 'bar',
                        data: moneyRateList,
                        color: '#1ec695',
                        barWidth: 16,
                        itemStyle: {
                            barBorderRadius: [6, 6, 0, 0],
                        },
                    }]
                });
                clear4= setInterval(() => {
                    myChart.resize();
                }, 500)
            },
            //预定统计
            getReportOrderCalc(){
                this.$axios.post('/report/reportOrderCalc', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    this.reportOrderCalc=res.data.list[0];
                }).catch(err => {

                })
            },
            //预定统计结算
            getReportOrderClear(){
                this.$axios.post('/report/reportOrderClear', {
                    "storeId": this.$root.getStorage('storeId'),
                    createStartTime:this.orderDateRange?this.orderDateRange[0]:'',
                    createEndTime:this.orderDateRange?this.orderDateRange[1]:'',
                    orderStartTime:this.dateRange?this.dateRange[0]:'',
                    orderEndTime:this.dateRange?this.dateRange[1]:'',
                    orderStates:this.orderStates,
                    packageIds:this.packageIds.join(','),
                    houseIds:this.houseIds.join(','),
                    createUserIds:this.createUserIds.join(','),
                }).then(res => {
                    this.reportOrderClear=res.data.list[0];
                }).catch(err => {

                })
            },
        },

        beforeDestroy() {
            clearInterval(clear1);
            clearInterval(clear2);
            clearInterval(clear3);
            clearInterval(clear4);

        }
    }
</script>

<style scoped lang="scss">
    .report-tag {
        margin-top: 10px;
        margin-left: 4px;
        position: relative;
        .title {
            position: absolute;
            width: 260px;
            line-height: 26px;
            margin-left: 26px;
            color: white;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
        }
        .tag-bg {
            width: 260px;
            height: 0px;
            box-shadow: 30px 10px 50px #fefefe;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border: {
                left: 26px solid transparent;
                bottom: 26px solid #94b6d2;
            }
        }
    }

    .report-total {
        margin-top: 10px;
        padding: {
            left: 80px;
            right: 80px;
        }
    ;
        & > div {
            color: #333333;
            font-size: 15px;
            font-weight: bold;
            padding: 0 10px;
            flex: 1;
        }
    }

</style>